import { DeleteOutlined } from "@ant-design/icons";
import { message, Input, Modal, Select, Button } from "antd";
import React, { useEffect, useState } from "react";
import {
  useProductTypeList,
  useGetProductById,
  useCreateProduct,
  useUpdateProduct,
} from "../../api/product";
import Password from "antd/es/input/Password";
import {
  useCreateBranch,
  useGetOrganizationByEmail,
  useGetOrganizationByName,
  useGetOrganizationByPhoneNumber,
} from "../../api/organization";
import { useGetUserByPhoneNumber, useGetUserByUserName } from "../../api/users";

type BranchModalProps = {
  open: boolean;
  selectedId: string;
  hideModal: () => void;
};
const CreateBranchModal: React.FC<BranchModalProps> = ({
  open,
  selectedId,
  hideModal,
}) => {
  const [name, setName] = useState<string | undefined>();
  const [email, setEmail] = useState<string>();
  const [phoneNumber, setPhoneNumber] = useState<string>();
  const [region, setRegion] = useState<string>();
  const [city, setCity] = useState<string>();
  const [kifleKetema, setKifleKetema] = useState<string>();
  const [woreda, setWoreda] = useState<string>();

  const [fullName, setFullName] = useState<string | undefined>();
  const [userName, setUserName] = useState<string | undefined>();
  const [contactEmail, setContactEmail] = useState<string | undefined>();
  const [contactPhoneNumber, setContactPhoneNumber] = useState<
    string | undefined
  >();
  const [type, setType] = useState<string | undefined>("OFF_TAKERS");
  const {
    mutateAsync: createBranch,
    isSuccess,
    isPending: creating,
  } = useCreateBranch();
  const {
    data: userNameData,
    refetch: fetchUserName,
    isLoading: loadingUserName,
  } = useGetUserByUserName(userName);
  const {
    data: phoneNumberData,
    refetch: fetchContactPhone,
    isLoading: loadingContactPhone,
  } = useGetUserByPhoneNumber(contactPhoneNumber);
  const {
    data: orgNameData,
    refetch: fetchOrgName,
    isLoading: loadingOrgName,
  } = useGetOrganizationByName(name);
  const {
    data: orgEmailData,
    refetch: fetchOrgEmail,
    isLoading: loadingOrgEmail,
  } = useGetOrganizationByEmail(email);
  const {
    data: orgPhoneNumberData,
    refetch: fetchOrgPhoneNumber,
    isLoading: loadingOrgPhoneNumber,
  } = useGetOrganizationByPhoneNumber(phoneNumber);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (userName) {
        fetchUserName();
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [userName]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (contactPhoneNumber) {
        fetchContactPhone();
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [contactPhoneNumber]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (name) {
        fetchOrgName();
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [name]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (email) {
        fetchOrgEmail();
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [email]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (phoneNumber) {
        fetchOrgPhoneNumber();
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [phoneNumber]);

  const onsubmit = async () => {
    const data = {
      name,
      shortName: "branch",
      email,
      phoneNumber,
      type,
      address: JSON.stringify({
        region,
        city,
        kifleKetema,
        woreda,
      }),
      contactPerson: {
        fullName,
        username: userName,
        email: contactEmail,
        phoneNumber: contactPhoneNumber,
        password: null,
      },
    };

    try {
      const result = await createBranch(data);

      if (result.data.status === "success") {
        message.success("Branch created successfully.");
      } else {
        message.error("Operation failed");
      }
    } catch (err: any) {
      message.error("Operation failed");
    } finally {
      hideModal();
    }
  };

  return (
    <Modal
      width={"70%"}
      title={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
            fontSize: 27.43,
            color: "black",
          }}
        >
          {selectedId ? "Edit branch" : "Create new "}
        </div>
      }
      open={open}
      centered
      onOk={onsubmit}
      okButtonProps={{
        disabled:
          userNameData?.data.data === true ||
          phoneNumberData?.data.status === "failed" ||
          orgEmailData?.data.status === "failed" ||
          orgPhoneNumberData?.data.status === "failed",
      }}
      onCancel={hideModal}
      closable
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          color: "black",
          gap: 40,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 12,
            width: "49%",
          }}
        >
          <div className="text-xl">Branch Info</div>
          <Input
            placeholder="Insert branch name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          {orgNameData &&
            orgNameData.data &&
            orgNameData.data.data === true && (
              <div className="text-red-400">{orgNameData.data.message}</div>
            )}
          <Input
            placeholder="Insert email"
            value={email || ""}
            onChange={(e) => setEmail(e.target.value)}
          />
          {orgEmailData &&
            orgEmailData.data &&
            orgEmailData.data.data === true && (
              <div className="text-red-400">{orgEmailData.data.message}</div>
            )}
          <Input
            placeholder="Insert phone number"
            value={phoneNumber || ""}
            onChange={(e) => setPhoneNumber(e.target.value)}
          />
          {orgPhoneNumberData &&
            orgPhoneNumberData.data &&
            orgPhoneNumberData.data.status === "failed" && (
              <div className="text-red-400">
                {orgPhoneNumberData.data.message}
              </div>
            )}

          <Select
            value={region}
            placeholder="Select region"
            style={{ width: "100%" }}
            onChange={(val: any) => setRegion(val)}
            options={[
              "Addis Ababa",
              "Amhara",
              "Benishangul",
              "Gambela",
              "Oromia",
              "Tigray",
              "SNNPE",
            ].map((region: string) => {
              return { label: region, value: region };
            })}
          />
          <Input
            placeholder="Insert city"
            value={city}
            onChange={(e) => setCity(e.target.value)}
          />
          <Input
            placeholder="Insert kifle ketema"
            value={kifleKetema}
            onChange={(e) => setKifleKetema(e.target.value)}
          />
          <Input
            placeholder="Insert woreda"
            value={woreda}
            onChange={(e) => setWoreda(e.target.value)}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 12,
            width: "49%",
          }}
        >
          <div className="text-xl">Contact person Info</div>
          <Input
            placeholder="Insert full name"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
          />
          <Input
            placeholder="Insert user name"
            value={userName || ""}
            onChange={(e) => setUserName(e.target.value)}
          />
          {userNameData &&
            userNameData.data &&
            userNameData.data.data === true && (
              <div className="text-red-400">{userNameData.data.message}</div>
            )}
          <Input
            placeholder="Insert email"
            value={contactEmail || ""}
            onChange={(e) => setContactEmail(e.target.value)}
          />
          <Input
            addonBefore={<div>+251</div>}
            placeholder="Insert phone number"
            value={contactPhoneNumber || ""}
            onChange={(e) => {
              let phone = e.target.value;
              // if (phone.startsWith('0')) {
              //     phone = phone.substring(1);
              // }
              setContactPhoneNumber(phone);
            }}
          />
          {phoneNumberData &&
            phoneNumberData.data &&
            phoneNumberData.data.status === "failed" && (
              <div className="text-red-400">{phoneNumberData.data.message}</div>
            )}
        </div>
      </div>
    </Modal>
  );
};

export default CreateBranchModal;
